import { FC } from 'react';
import { FlagshipProvider } from '@embark/shared-components/src/flagship/flagshipProvider';
import { useAppSelector } from 'projects/legacyClient/src/react/state/hooks';

/**
 * Simple wrapper component around the more generic FlagshipProvider that pulls the user info from the Redux store.
 */
export const FlagshipProviderRedux: FC = (props) => {
  const { children } = props;
  const accountDetails = useAppSelector((state) => state.accountDetails);

  return <FlagshipProvider accountDetails={accountDetails}>{children}</FlagshipProvider>;
};
